export default {
  getProfile: (state) => state.profile,
  getPersonalInfo: (state) => state.personalInfo,
  getAddress: (state) => state.address,
  getPhoto: (state) => state.photo,
  getNationality: (state) => state.nationality,
  getMaritalStatus: (state) => state.maritalStatus,
};
